// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPassword1_root__kIpm-","rootdanger":"PlasmicPassword1_rootdanger__lv5F0"};